<template>
  <pt-taxation-project-form ref="form" class="pt-taxation-project-form__withData" :taxDetail="taxDetail" :loading="loading"></pt-taxation-project-form>
</template>

<script>
import PtTaxationProjectForm from './form'
export default {
  name: 'pt-taxation-project-form__withData',
  components: {
    'pt-taxation-project-form': PtTaxationProjectForm
  },
  computed: {
    form () {
      return this.$refs.form
    }
  },
  props: {
    id: {
      type: String,
      default: ''
    },
    isEdit: {
      type: Boolean,
      default: false
    }
  },
  data () {
    return {
      taxDetail: null,
      loading: false
    }
  },
  methods: {
    // 获取税务项目详情
    getTaxPrejectDetail () {
      this.loading = true
      this.$store.dispatch('getTaxPrejectDetail', this.id).then(res => {
        this.loading = false
        this.taxDetail = res
      }).catch(err => {
        this.loading = false
        this.$message.error(err || '获取税率项目失败')
      })
    },
    submit () {
      this.form.validate().then(formValue => {
        let submitApi = this.isEdit ? 'editTaxProject' : 'creatTaxProject'
        this.$emit('submitLoad', true)
        this.$store.dispatch(submitApi, formValue).then(data => {
          // doing something ...
          this.$emit('submitLoad', false)
          this.$message.success('新建税率项目成功')
          history.go(-1)
        }).catch(errorMessage => {
          this.$emit('submitLoad', false)
          this.$message.error(errorMessage || '新建税率项目失败')
        })
      })
    }
  },
  created () {
    if (this.isEdit) {
      this.getTaxPrejectDetail()
    }
  }
}
</script>
